<template>
  <div>
    <v-row style="height: 60px;" class="box-header">
      <v-col offset="6" cols="6">
        <div class="gr-action d-flex justify-end">
          <div class="box-product-type px-1">
            <v-text-field
              class="v-select-mini pt-0"
              :clearable="true"
              label=""
              outlined
              dense
              placeholder="Tìm theo tên chiến dịch"
              v-model="searchTitle"
              @keyup.enter="getData(1)"
            ></v-text-field>
          </div>

          <v-btn
            class="btn-search"
            small
            @click="getData(1); isShowAdvanceSearch = false;"
          >
            <v-icon color="#B3B3B3">
              mdi-magnify
            </v-icon>
          </v-btn>

          <v-btn
            class="btn-search"
            small
            style="position: relative;"
            @click="isShowAdvanceSearch = !isShowAdvanceSearch"
          >
            <span>Tìm kiếm nâng cao</span>
          </v-btn>
          <v-card v-if="isShowAdvanceSearch" class="mx-auto overflow-visible px-6 box-advance-search" width="800px" outlined>
            <v-row>
              <v-col class="text-center text-bold" cols="12">
                <span>Tìm kiếm nâng cao</span>
              </v-col>
              <v-col>
                <div class="d-flex justify-end box-action">
                  <span class="close-btn cursor-pointer" @click="isShowAdvanceSearch = false">
                    <v-icon color="#9e9e9e">
                      mdi-close
                    </v-icon>
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-select
                  class=""
                  :clearable="true"
                  :items="campaignTypes"
                  item-value="id"
                  item-text="name"
                  :aLight="'right'"
                  label="Loại chiến dịch"
                  placeholder="Chọn loại chiến dịch"
                  attach
                  outlined
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '250' }"
                  v-model="searchType"
                ></v-select>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-select
                  class=""
                  :clearable="true"
                  :items="campaignForms"
                  item-value="id"
                  item-text="name"
                  :aLight="'right'"
                  label="Hình thức áp dụng"
                  placeholder="Chọn hình thức áp dụng"
                  attach
                  outlined
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '250' }"
                  v-model="searchFormOfApplication"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-select
                  class="text-field-no-message"
                  :clearable="true"
                  :items="statuses"
                  item-value="id"
                  item-text="name"
                  :aLight="'right'"
                  label="Trạng thái"
                  placeholder="Chọn trạng thái"
                  attach
                  outlined
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '300' }"
                  v-model="searchStatus"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="box-date">
              <v-col cols="6" class="py-0">
                <common-range-picker
                  class="date-range-custom"
                  :clearable="true"
                  :showRanges="false"
                  placeholder="From-to"
                  :aLight="'left'"
                  :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                  label="Thời gian bắt đầu"
                  v-model="startDate"
                  @show-date-picker="showDate(1)"
                ></common-range-picker>
              </v-col>
              <v-col cols="6" class="py-0">
                <common-range-picker
                  class="date-range-custom"
                  placeholder="From-to"
                  :clearable="true"
                  :showRanges="false"
                  :aLight="'left'"
                  :class="this.currentPicker === 2 ? 'show-date' : 'hide-date'"
                  label="Thời gian kết thúc"
                  v-model="endDate"
                  @show-date-picker="showDate(2)"
                ></common-range-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center" cols="12">
                <v-btn
                  class="btn-search-advance"
                  small
                  @click="getData(1);isShowAdvanceSearch = false"
                >
                  Tìm kiếm
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-btn
            class="btn-create-product"
            small
            @click="createCampaign()"
          >
            Thêm chiến dịch
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <ListCampaign style="min-height: 600px;" v-if="campaignOptions" :campaignOptions="campaignOptions" :isLoading="isLoading" :data="listData" />
    <v-row>
      <v-col offset="4" cols="8" class="py-0">
        <v-row v-if="totalPage">
          <v-col cols="7" class="d-flex justify-end py-0">
            <p class="pt-3">Rows per page:</p>
          </v-col>
          <v-col cols="1" class="justify-end py-0">
            <v-select
              class="text-field"
              :items="[{ id: 10 },{ id: 20 },{ id: 30 },{ id: 40 },{ id: 50 }]"
              item-value="id"
              item-text="id"
              :aLight="'right'"
              placeholder="Chọn"
              attach
              dense
              type="number"
              v-model="numPerPage"
              @change="getData(1)"
              :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
            ></v-select>
          </v-col>
          <v-col cols="1" class="justify-end py-0">
            <p class="pt-3 text-center">
              {{ (page - 1) * numPerPage + 1 }}-{{ (page - 1) * numPerPage + listData.length }} of {{ totalItem }}
            </p>
          </v-col>
          <v-col cols="3" class="px-0 py-0">
            <v-pagination
              v-model="page"
              class="d-flex justify-end pagination-custom"
              :length="totalPage"
              :total-visible="7"
              @input="getData()"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const CampaignRepository = RepositoryFactory.get('campaign');

import ListCampaign from './components/list/ListCampaign.vue';

export default {
  components: {
    ListCampaign,
  },
  data() {
    return {
      item: null,
      listData: [],
      searchParams: {
        root_category_id: null,
        status: 'active',
      },
      isLoading: false,
      campaignOptions: null,
      startDate: null,
      endDate: null,
      page: 1,
      totalPage: null,
      numPerPage: 10,
      totalItem: null,
      searchCode: null,
      searchStatus: null,
      searchStartDate: null,
      searchEndDate: null,
      searchType: null,
      searchFormOfApplication: null,
      searchTitle: null,
      campaignTypes: [],
      campaignForms: [],
      statuses: [],
      isShowAdvanceSearch: false,
    };
  },
  computed: {
  },
  async created() {
    this.getListAttributes();
    this.getData();
  },
  beforeDestroy() {
  },
  methods: {
    async getData(page = null) {
      if (page) {
        this.page = 1;
      }
      this.listData = [];
      this.isLoading = true;
      let params = {
        code: this.searchCode,
        status: this.searchStatus,
        startDate: this.startDate,
        endDate: this.endDate,
        type: this.searchType,
        formOfApplication: this.searchFormOfApplication,
        title: this.searchTitle,
        limit: this.numPerPage,
        page: this.page,
      };

      const res = await CampaignRepository.getList(params);
      this.listData = res.data;
      this.totalItem = res.totalItem;
      this.totalPage = Math.ceil(res.totalItem / this.numPerPage);
      this.isLoading = false;
    },

    async getListAttributes() {
      const res = await CampaignRepository.getOptions();
      this.campaignOptions = res.data;
      this.campaignTypes = res.data.type;
      this.campaignForms = res.data.applicableForm;
      this.statuses = res.data.status;
    },

    createCampaign() {
      this.$router.push('/campaign/create')
    },
  },
  watch: {
    // currentPage: {
    //   handler() {
    //     this.addHashToLocation( {...this.filterForm, page: this.currentPage });
    //     this.getList();
    //   }
    // },
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  // width: 500px;
  // height: 600px;
  // position: sticky !important;
  top: 120px;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search-advance {
  background: #8465FF !important;
}

.box-product-type {
  width: 300px;
}

.box-header {
	position: sticky;
	background: #FAFBFF;
	top: 0px;
}

.box-advance-search {
  position: absolute;
  top: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  z-index: 10;
  border: 1px solid #ccc !important;
}

.box-action {
  position: relative;
  top: -45px;
}

</style>

<style lang="scss">
.date-range-custom {
  margin-top: 0 !important;

  .reportrange-text {
    border: 1px solid #9E9E9E !important;
    height: 55px !important;
    line-height: 55px;
    border-radius: 5px;
    padding-left: 10px !important;
  }
  label {
    position: relative !important;
    width: 100px;
    top: 10px !important;
    background: #FFFFFF;
    z-index: 10;
    left: 10px;
  }
}
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
    background: #fff !important;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.cursor-pointer {
  cursor: pointer;
}
.pagination-custom {
  li button{
    box-shadow: none !important;
		color: #3F51B5 !important;
  }

	.v-pagination__item--active {
		color: #000 !important;
		background: #fff !important;
	}
}
</style>
